<template>
  <div class="view marketing campaigns">
    <div class="page">
      <div class="header">
        <h3 class="text-black mt-2 mb-3"><strong>Campaigns Management</strong></h3>
      </div>
      <div class="content">
        <div class="card">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0">
                Campaigns List
                <span :key="meta.total" class="animated fadeIn">({{ meta.total }})</span>
              </h5>
            </div>

            <div class="d-flex flex-column justify-content-center">
              <span>
                <a-button type="default" icon="sync" class="mr-2" @click="fetch"> Refresh </a-button>
                <a-button type="primary" icon="plus" @click="onNewCampaign"> New Campaign </a-button>
              </span>
            </div>
          </div>
          <!-- table -->
          <a-table
            :loading="loading"
            :columns="columns"
            :dataSource="campaigns"
            :rowKey="(record, index) => record._id"
            :scroll="{ x: 1200 }"
            :pagination="pagination"
            @change="change"
          >
            <span slot="id" slot-scope="_id">
              <strong>{{ _id | SHORT_ID_ }}</strong>
            </span>

            <span slot="status" slot-scope="campaign">
              <a-tag class="status" :class="campaign.status" :color="campaign.status | CAMPAIGN_STATUS_COLOR_">
                {{ campaign.status | CAMPAIGN_STATUS_ }}
              </a-tag>
            </span>

            <span slot="notification_channel" slot-scope="notification_channel">
              <a-tag color="blue">
                {{ notification_channel | CAPITALIZE_ }}
              </a-tag>
            </span>

            <span slot="description" slot-scope="description">
              <div class="sticker">{{ description }}</div>
            </span>

            <span slot="scheduled" slot-scope="scheduled">
              <span :class="{ due: isOverDue(scheduled) }"> {{ scheduled | moment('lll') }} </span>
            </span>

            <span slot="created_at" slot-scope="created_at">
              <span> {{ created_at | moment('lll') }} </span>
            </span>

            <span slot="actions" slot-scope="campaign">
              <a-button type="primary" class="ml-1" @click="onEdit(campaign._id)" size="small" icon="edit"
                >Edit</a-button
              >
            </span>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import options from '@/options'
import router from '@/router'
const KEY = 'campaigns'

export default {
  data() {
    return {
      columns: [
        {
          title: 'ID',
          dataIndex: '_id',
          key: '_id',
          width: 80,
          fixed: 'left',
          scopedSlots: { customRender: 'id' },
        },
        {
          title: 'Channel',
          key: 'notification_channel',
          dataIndex: 'notification_channel',
          width: 100,
          fixed: 'left',
          align: 'center',
          filters: [
            { text: 'Email', value: 'email' },
            { text: 'SMS', value: 'sms' },
          ],
          filterMultiple: false,
          scopedSlots: { customRender: 'notification_channel' },
        },
        {
          title: 'Status',
          key: 'status',
          width: 100,
          fixed: 'left',
          align: 'center',
          filters: options.CAMPAIGN_STATUS.map((s) => {
            return { text: s.value, value: s.key }
          }),
          filterMultiple: false,
          scopedSlots: { customRender: 'status' },
        },

        {
          title: 'Sender Name',
          dataIndex: 'sender',
          key: 'sender',
          // width: 150,
        },
        {
          title: 'Title',
          dataIndex: 'title',
          key: 'title',
          // width: 220,
          ellipsis: true,
        },
        {
          title: 'Description',
          dataIndex: 'description',
          key: 'description',
          width: 220,
          scopedSlots: { customRender: 'description' },
        },
        {
          title: 'Scheduled',
          dataIndex: 'scheduled',
          key: 'scheduled',
          width: 120,
          scopedSlots: { customRender: 'scheduled' },
        },
        {
          title: 'Created',
          dataIndex: 'created_at',
          key: 'created_at',
          width: 120,
          scopedSlots: { customRender: 'created_at' },
        },
        {
          title: 'Actions',
          key: 'actions',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'actions' },
        },
      ],
    }
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('marketing/fetchCampaigns')
    },
    onNewCampaign() {
      // this.$store.dispatch('marketing/open', 'CREATE_CAMPAIGN')
      this.$router.push({ name: 'campaign-create' })
    },
    onEdit(id) {
      this.$router.push({ name: 'campaign-detail', params: { id } })
    },
    change(pagination, filters, sorter) {
      this.$store.dispatch('marketing/updateQuery', { key: KEY, query: { pagination, filters, sorter } })
    },
    isOverDue(date) {
      return new Date().getTime() > new Date(date).getTime()
    },
  },
  computed: {
    loading() {
      return this.$store.getters['marketing/loading'](KEY)
    },
    campaigns() {
      return this.$store.getters['marketing/data'](KEY)
    },
    pagination() {
      return this.$store.getters['marketing/pagination'](KEY)
    },
    meta() {
      return this.$store.getters['marketing/meta'](KEY)
    },
  },
  async created() {
    await this.fetch()
  },
  mounted() {
    console.log(this.$store.getters['marketing/data'](KEY))
  },
  destroyed() {
    // store.dispatch('marketing/init')
  },
}
</script>

<style lang="scss" scoped>
.marketing.campaigns {
  .status {
    border: none;
    text-transform: capitalize;
    background: #666;
    color: #fff;

    &.confirmed {
      background: #00b44b;
    }

    &.in_progress {
      background: #008d0c;
    }
  }
  .dot {
    display: inline-block;
    height: 0.86rem;
    width: 0.86rem;
    background: #666;
    border-radius: 20px;
    vertical-align: middle;
    position: relative;
    top: -2px;

    &.active {
      background: #00b44b;
    }
  }

  .sticker {
    background: #ffeb3b;
    padding: 2px 8px;
    color: #000;
    border-radius: 3px;
    font-size: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    box-shadow: 0 0 10px #eee;
  }

  .due {
    color: #9c9c9c;
  }
}
</style>
